import { HttpClient } from './HttpClient';
import { ICastingNotes } from 'models';
import { getApiUrl } from './UrlBuilder';
import { HALManager } from 'core';

export class CastingDirectorService {
  private httpClient: HttpClient = new HttpClient();

  public async getNotes(profileId: string, castingId: string) {
    const requestUrl = getApiUrl(HALManager.getCastingNotesUrl(profileId, castingId));

    const { object: notes } = await this.httpClient.get<ICastingNotes>(requestUrl);

    return notes;
  }

  public async saveNotes(profileId: string, castingId: string, notes: ICastingNotes) {
    const requestUrl = getApiUrl(HALManager.putCastingNotesUrl(profileId, castingId));

    const { object: updatedNotes } = await this.httpClient.put<ICastingNotes>(requestUrl, {
      body: JSON.stringify(notes),
    });

    return updatedNotes;
  }
}

export default new CastingDirectorService();
